import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import CatThumb from "../../utils/components/CatThumb";
import { global } from "../../App/routes";

import { RectShape, TextBlock } from "react-placeholder/lib/placeholders";
import ReactPlaceholder from "react-placeholder/lib";

import "react-placeholder/lib/reactPlaceholder.css";
import API from "../../utils/API";
import ProductSlider from "./PopularActivities/ProductSlider";

const ProductPlaceholder = () => (
  <div className="product-placeholder">
    <RectShape
      className="cover-placeholder placeholder-item"
      style={{ height: "auto", margin: 0, marginBottom: 10 }}
    />
    <TextBlock
      className="cat-placeholder placeholder-item"
      style={{ width: "20%", marginBottom: 8 }}
    />
    <TextBlock
      className="name-placeholder placeholder-item"
      rows={2}
      style={{ width: "75%", marginBottom: 5 }}
    />
    <div className="stats-placeholder d-flex justify-content-start align-items-center">
      <RectShape
        className="stat-placeholder placeholder-item"
        style={{
          width: 49,
          height: 22,
          borderRadius: 2,
          marginRight: 12,
          marginTop: 10,
          marginBottom: 15,
        }}
      />
      <TextBlock
        className="price-placeholder placeholder-item"
        row={1}
        style={{ width: 50 }}
      />
    </div>
    <TextBlock
      className="price-placeholder placeholder-item"
      row={1}
      style={{ width: 50, marginBottom: 15 }}
    />
    <TextBlock
      className="availability-placeholder placeholder-item"
      row={1}
      style={{ width: 75, marginBottom: 15 }}
    />
  </div>
);

const catProductPlaceholder = (
  <div className="product-slider-placeholder w-100 d-flex justify-content-center align-items-center overflow-hidden">
    <div className="products-holder d-flex d-md-none justify-content-center align-items-center">
      {Array.from(Array(3).keys()).map((data) => (
        <ProductPlaceholder key={data} />
      ))}
    </div>
    <div className="products-holder d-none d-md-flex justify-content-start align-items-center">
      {Array.from(Array(4).keys()).map((data) => (
        <ProductPlaceholder key={data} />
      ))}
    </div>
  </div>
);

const placeholder = (
  <div className="cat-thumb-placeholder overflow-auto w-100">
    {Array.from(Array(8).keys()).map((data) => (
      <RectShape key={data} className="placeholder-item m-0" />
    ))}
  </div>
);

export default function MostLikedCats(props) {
  const [selectedCat, setSelectedCat] = React.useState(null);
  const [products, setProducts] = React.useState([]);
  const [isProductsLoading, setIsProductsLoading] = React.useState(false);

  useEffect(() => {
    if (props.mostLikedCats.length && selectedCat === null)
      setSelectedCat(props.mostLikedCats[0]);
  }, [props.mostLikedCats, selectedCat]);

  useEffect(() => {
    if (selectedCat?.id) getSelectedCatProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.user.currencyPref.code, props.user.langPref, selectedCat]);

  const getSelectedCatProducts = () => {
    setIsProductsLoading(true);
    API.get(
      `products?currency=${props.user.currencyPref.code}&category_id=${selectedCat?.id}&limit=8&page=1`
    )
      .then(({ data: res }) => {
        setProducts(res.data);
        setIsProductsLoading(false);
      })
      .catch(() => setIsProductsLoading(false));
  };

  return (
    <section className="most-liked-cats w-border" ref={props.propRef}>
      <div className="container">
        <div className="row">
          <div className="col d-flex align-items-center flex-column">
            <h4 className="section-title text-center">
              {props.translate("home.most_liked_cats.title")}
            </h4>
            <p className="section-desc text-center">
              {props.translate("home.most_liked_cats.desc")}
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div
              className={`cats-holder main-cat mx-auto overflow-auto mw-100 ${
                !props.isReady
                  ? `d-flex justify-content-center overflow-hidden w-100`
                  : ``
              }`}
            >
              <ReactPlaceholder
                ready={props.isReady}
                customPlaceholder={placeholder}
                showLoadingAnimation
              >
                {props.mostLikedCats &&
                  props.mostLikedCats.map((data, index) => {
                    const url = global.catPage.links[props.lang].replace(
                      ":main_cat",
                      data.slug
                    );
                    return (
                      <CatThumb
                        key={data.id}
                        link={url}
                        name={data.title}
                        image={data.thumb_image}
                        handlePromotionClick={
                          props.handlePromotionClick
                            ? () =>
                                props.handlePromotionClick(
                                  { title: data.title, index: index + 1 },
                                  `En Beğenilen Kategoriler`
                                )
                            : null
                        }
                        homeFix
                        className={selectedCat?.id === data.id ? `active` : ``}
                        onClick={() => setSelectedCat(data)}
                      />
                    );
                  })}
              </ReactPlaceholder>
            </div>
          </div>
        </div>

        {selectedCat && (
          <div className="row mt-4">
            <div className="col">
              <ReactPlaceholder
                ready={!isProductsLoading}
                customPlaceholder={catProductPlaceholder}
                showLoadingAnimation
              >
                <ProductSlider
                  currency={props.user.currencyPref}
                  products={products}
                  user={props.user}
                  slidesPerView={props.slidesPerView}
                />
              </ReactPlaceholder>
            </div>
          </div>
        )}
        <div className="row">
          <div className="col d-flex justify-content-center">
            <Link to="#!" className="show-all-button d-none align-items-center">
              {props.translate("global.view_all_categories")}
              <svg
                width="8"
                height="13"
                viewBox="0 0 8 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1L7 6.5L1 12"
                  stroke="#E75B2B"
                  strokeWidth="1.4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
